/**
 * 帮助中心
 * created by liyaoh: 2022-03-04
 */
import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { langCheck, startIntro, GetQuery, imLogin, OSnow, getWindow } from "Pub/js/utils";
import loadjs from 'loadjs';
import platform from "Pub/js/platform";
import { globalHotKeys } from "Pub/js/globalHotKeys";
import pubSubActions from "Pub/js/pubSubActions";
import "./index.less";
const { PubSub } = platform;
const { NCTooltip, NCDropdown, NCMenu } = platform.base;
const { Item } = NCMenu;
import { withRouter } from "react-router-dom";
import { sessionStorageUtil } from "Pub/js/storageUtils";

function HelpCenter(props) {
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [helpSdkReady, setHelpSdkReady] = useState(false);
    // const [information, setInformation] = useState({});

    const handleVisibleChange = visible => {
        setDropdownVisible(visible);
    };

    useEffect(() => {
        //绑定快捷键
        globalHotKeys.bind(hotkeys => hotkeys.HELP, openHelpCenter);
        //监听iframe点击事件关闭dropdown
        const ifrClickPubSub = PubSub.subscribe(pubSubActions.global.onIframeClick, (key, event) => {
            //异步回调拿不到最新visible的值，需要写成函数式更新
            setDropdownVisible(preVisible => {
                if (preVisible !== undefined && preVisible !== dropdownVisible) {
                    return false;
                }
            });
        });

        return () => {
            //移除spr快捷键
            globalHotKeys.remove(hotkeys => hotkeys.HELP, openHelpCenter);
            PubSub.unsubscribe(ifrClickPubSub); //移除订阅
        };
    }, []);

    const handleSelect = ({ key }) => {
        setDropdownVisible(false);
        switch (key) {
            //帮助中心
            case "help":
                openToHelpCenter();
                break;
            //功能引导
            case "guide":
                startIntro();
                break;
            default:
                break;
        }
    };
    const getSDKUrl = profile => {
        const sdkUrlMap = {
            online: 'c2', // 生产
            pre: 'bip-pre', // 预发
            daily: 'bip-daily', // 日常
        };
        const jsUrl = `https://${sdkUrlMap[profile]}.yonyoucloud.com/iuap-hc-client/ucf-wh/client/sdk/helpcenterSDK.js`;
        const cssUrl = `https://${sdkUrlMap[profile]}.yonyoucloud.com/iuap-hc-client/ucf-wh/client/sdk/helpcenter.css`;
        return [jsUrl, cssUrl];
    };
    const openHelpCenter = async () => {
        const information = await imLogin();
        if (information) {
            const open = () => {
                setHelpSdkReady(true);
                // let { c = 'newbie_guide', ifr } = GetQuery(props.location.search);
                // 直接从window上取hash，props取的话快捷键的值不对，是第一次的
                const search = getWindow().location.hash && getWindow().location.hash.split('?') && getWindow().location.hash.split('?')[1];
                let { c = 'newbie_guide', ifr } = GetQuery(`?${search}`);
                if (ifr && ifr.includes('tplpagetype=mobile')) { // 移动设计器特殊处理
                    c = '102202MOBSANDBOX';
                }
                const { yhturl, productline, xiaoyou_token, profile, dataCenter, tenantid } = information;
                const params = {
                    productline,
                    serviceCode: c,
                    originUrl: yhturl,
                    token: xiaoyou_token,
                    profile,
                    env: 'YonBIPPremium',
                    dataCenter,
                    ytenantId: tenantid,
                    publicCloud: false,
                    locale: 'zh_CN',
                };
                window.helpcenterSDK && window.helpcenterSDK.mount(params);
            };
            if (helpSdkReady) {
                open();
            } else {
                const { profile } = information;
                const urlArr = getSDKUrl(profile);
                loadjs(urlArr, open);
            }
        }
    };
    // // 打开帮助中心侧拉
    // const openHelpCenterModal = (productline, c, yhturl) => {
    //     const params = { productline, serviceCode: c, originUrl: yhturl };
    //     window.helpcenterSDK && window.helpcenterSDK.mount(params);
    // }
    // 直接跳转帮助中心
    const openToHelpCenter = async () => {
        const information = await imLogin();
        if (information) {
            let openUrl = '';
            const { c = '' } = GetQuery(props.location.search);
            const { helpcenter_url, productline } = information;
            if (c) {
                openUrl = `${helpcenter_url}ysdetail/${c}?productline=${productline}`;
            } else {
                openUrl = `${helpcenter_url}?productline=${productline}`;
            }
            window.open(openUrl);
        }
    };
    // const getHelpCenterUrl = () => {
    //     const { c = '' } = GetQuery(props.location.search);
    //     return new Promise((resolve, reject) => {
    //         Ajax({
    //             url: "/nccloud/platform/helpcenter/helpcenterurl.do",
    //             data: {
    //                 appcode: c,
    //             },
    //             success: ({ data: { data, success } }) => {
    //                 if (success && data) {
    //                     const { url, productline, yhturl } = data;
    //                     setInformation({
    //                         url,
    //                         productline,
    //                         yhturl
    //                     });
    //                     resolve(data);
    //                 } else {
    //                     const { message } = data;
    //                     Notice({
    //                         status: "error",
    //                         msg: message
    //                     });
    //                 }
    //             }
    //         });
    //     })

    // }
    const menu = (
        <NCMenu onClick={handleSelect}>
            <Item key="help">
                <div className="helpcenter-dropdown-item">
                    <i className="iconfont icon-bangzhuzhongxin1" />
                    {langCheck("0000PUB-000479")} {/* 帮助中心 */}
                </div>
            </Item>
            <Item key="guide">
                <div className="helpcenter-dropdown-item">
                    <i className="iconfont icon-gongnengyindao" />
                    {langCheck("0000PUB-000438")} {/* 新手指引 */}
                </div>
            </Item>
        </NCMenu>
    );
    const getTooltipText = () => {
        let text = langCheck("0000PUB-000607"); // "帮助（Ctrl+F1）"
        if (OSnow() === 'mac') {
            text = langCheck("0000PUB-000609");   // "帮助（command+F1）"
        }
        return text;
    }
    return (
        <div className={classNames("nc-help-center-container item-wrap ", { active: dropdownVisible })}>
            <NCTooltip
                placement="bottom"
                overlay={getTooltipText()}
                trigger="hover"
                delayShow={500}
                delay={1}
                mouseLeaveDelay={0}
            >
                <div className="iconContainer" onClick={openHelpCenter}>
                    <i className="iconfont icon-bangzhuzhongxin" />
                </div>
            </NCTooltip>
            {/* <NCDropdown
                overlay={menu}
                trigger={["click"]}
                visible={dropdownVisible}
                placement="bottomRight"
                overlayClassName="helpcenter-dropdown-container"
                onVisibleChange={handleVisibleChange}
            >
                <div className="help-center-arrow"></div>
            </NCDropdown> */}
        </div>
    );
}

export default withRouter(HelpCenter);
